import { render, staticRenderFns } from "./VideoDirectorConfigEdit.vue?vue&type=template&id=22970336&"
import script from "./VideoDirectorConfigEdit.vue?vue&type=script&lang=js&"
export * from "./VideoDirectorConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports